// removed by extract-text-webpack-plugin
module.exports = {"avatar":"ContactAvatar-hashed__avatar__s1wN-","inactive":"ContactAvatar-hashed__inactive__3HNIl","active":"ContactAvatar-hashed__active__2TWBb"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/ContactAvatar/ContactAvatar-hashed.scss
// module id = 1178
// module chunks = 0